<div>
  <div style="display: block;height: 210px;">
    <canvas *ngIf="lineChartData.labels.length > 0" baseChart width="500" height="150"
      [type]="'line'"
      [data]="lineChartData"
      [options]="lineChartOptions"
      [legend]="lineChartLegend">
    </canvas>
  </div>
</div>
